import {DropzoneComponent} from 'react-dropzone-component';
import 'react-dropzone-component/styles/filepicker.css';
import 'dropzone/dist/min/dropzone.min.css';
import React, {Component} from 'react';
import { Button, Header, Icon, Modal, Card, Grid, Form, Input, Segment, Image,List,Divider,Dropdown, Message } from 'semantic-ui-react';
import * as AlarmPlaceholder from "../../assets/placeholderImage.png";
import {uploadPVAlarmDetails, uploadPVAlarmImages} from "../../data/property_visit_api";
import { isSessionExpiringSoon } from '../../utils/validate_session_expiry';
import Loader from "../universal/loader";

const uuidv1 = require('uuid/v1');

class PropertyVisitReportAlarms extends Component {

  constructor(props) {
    super(props);
    this.state = {
      saved: false,
      uploading: false,
      alarmType: undefined,
      alarmLocation: undefined,
      alarmDescription: undefined,
      alarmExpiry:undefined,
      attachments: [],
      showAdd: true,
      alarms: [],
      notSaved: false,
      currentImageCount: 1,
      totalImageCount:0,
      absenceReason:""
    };
  }
  
  componentDidMount() {
    if (this.props.reportData) {
      let alarmList = []
      
      this.props.reportData.property_visit_alarms.map((alarm) => {
        let newAlarm = {
          alarmType: alarm.alarm_type,
          alarmLocation: alarm.alarm_location,
          alarmDescription: alarm.alarm_description,
          alarmExpiry:alarm.alarm_expiry,
          client_id: alarm.client_id,
          image: { image_path: alarm.file.report.url }
        }
        alarmList.push(newAlarm);

      })
      this.setState({ alarms: alarmList,absenceReason:this.props.reportData.carbon_absent_reason || "" })
    }
  
  }

  uploadAlarms = async () => {
    if(isSessionExpiringSoon()){
      this.props.showPasswordWindow(true);
      return;
  }
    this.setState({ uploading: true,uploadState:"text"});
    
    let reportUpdateAlarms = JSON.parse(JSON.stringify(this.state.alarms));
    let images = [];

    let formData = { report_id: this.props.reportId, alarms: reportUpdateAlarms, absence_reason:this.state.absenceReason }

    for (let i = 0; i < reportUpdateAlarms.length; i++) {

      if (reportUpdateAlarms[i]['image']) {

        let alarmImage = reportUpdateAlarms[i]['image'];
        if (alarmImage["dataURL"]) {
          images.push(this.state.alarms[i].image)
          reportUpdateAlarms[i]['image'] = undefined
        }
      }
    }
    await uploadPVAlarmDetails(formData)
    this.setState({totalImageCount:images.length,uploadState:"image"})
    for (let i = 0; i < images.length; i++){
      this.setState({currentImageCount: i+1})
    const imageFormData = new FormData();
  imageFormData.append("id", images[i].id);
  imageFormData.append("file", images[i]);
      await uploadPVAlarmImages(imageFormData)

    }
    
    this.setState({ notSaved: false,saved:true,uploading:false })
    setTimeout(() => {
      this.setState({saved:false})
    }, 3000);
  };

  deleteAlarm = (index) => {
    let newAlarms = [...this.state.alarms]
    newAlarms.splice(index,1)
    this.setState({alarms:newAlarms,notSaved:true})
  }
  
  handleSubmit = () => {

    let newClientId = uuidv1()
    let alarmImage = this.state.attachments.length > 0 ? this.state.attachments[0] : { image_path: undefined }
    alarmImage["id"] = newClientId
    let newAlarm = {
      alarmType: this.state.alarmType,
      alarmLocation: this.state.alarmLocation,
      alarmDescription: this.state.alarmDescription,
      alarmExpiry:this.state.alarmExpiry,
      client_id: newClientId, 
      image: alarmImage
    }
    this.setState({ alarmType: undefined, alarmLocation: undefined, alarmDescription: undefined, alarmExpiry:undefined, attachments: [], alarms: [...this.state.alarms, newAlarm], showAdd: false,notSaved:true }, () => {
      this.setState({ showAdd: true })
    });
  }


  render() {
      
    let dropZone = null;
    const componentConfig = {postUrl: 'no-url'};
    let djsConfig = {autoProcessQueue: false, addRemoveLinks: true, maxFiles: 1,acceptedFiles:"image/*"};
    const eventHandlers = {
        init: (dropzone) => {
            dropZone = dropzone;
            dropZone.autoDiscover = false;
        },
      addedfile: (file) => {
            this.state.attachments.push(file);
            this.setState({fileAdded:true,preLoaded:false});
        },
        removedfile: (file) => {
            this.setState({attachments:[]});            },
        maxfilesexceeded: (file) => {
            dropZone.removeFile(file);
            this.setState({maxNumberOfFilesExceeded: true});
            setTimeout(() => {
                this.setState({maxNumberOfFilesExceeded: false})
            }, 10000)
        }
    };


    return (
      <Segment >
       <div>
          <Header textAlign="left"> Alarms{this.state.saved && <span className="info-success">Saved!</span>}
            {this.state.notSaved && <span className="info-negative">Not Saved</span>}

            <Button primary compact content="Save" disabled={this.state.uploading|| (this.state.alarms.filter(alarm => {return alarm.alarmType === "Carbon Alarm"}).length === 0 && this.state.absenceReason === "")} loading={this.state.uploading}
              className="pull-right icon-button" onClick={(e) => {
                this.uploadAlarms();
              }} /> </Header>
          {!this.state.uploading && <React.Fragment><Grid centered columns={3} divided="vertically">
            <Grid.Row>
              {this.state.alarms.map((alarm, index) => <Grid.Column key={index}>
         
                <Card style={{ margin: "auto" }}>
                  <Image height="200px" src={alarm["image"]['image_path'] ? alarm["image"]['image_path'] : (alarm["image"]["dataURL"] ? alarm["image"]['dataURL'] : AlarmPlaceholder)} />
                  <Card.Description>
                    <div style={{ padding: "10px" }}><List>
                      <List.Item>
                        <List.Header>Alarm Type</List.Header>
                        <List.Description>{alarm.alarmType}</List.Description>
                      </List.Item>
                      <List.Item>
                        <List.Header>Alarm Location</List.Header>
                        <List.Description>{alarm.alarmLocation}</List.Description>
                      </List.Item>
                      <List.Item>
                        <List.Header>Alarm Description</List.Header>
                        <List.Description>{alarm.alarmDescription}</List.Description>
                      </List.Item>
                      <List.Item>
                        <List.Header>Alarm Expiry</List.Header>
                        <List.Description>{alarm.alarmExpiry}</List.Description>
                      </List.Item>
                    </List>
                    </div></Card.Description>
                  <Button color="red" icon onClick={() => { this.deleteAlarm(index) }}><Icon name="close" />Delete</Button>
                </Card>
              </Grid.Column>)}
            </Grid.Row>
            {this.state.alarms.filter(alarm => {return alarm.alarmType === "Carbon Alarm"}).length === 0 && <Grid.Row><Grid.Column width={8}><Message negative><Message.Header>No Carbon Alarm Found</Message.Header><Message.Content>Please add a carbon alarm or select the reason for absence to enable saving: <p/><Dropdown fluid  value={this.state.absenceReason} onChange={(e,option) => { this.setState({ absenceReason: option.value }) }} inline selection placeholder={"Choose Absence Reason..."} options={[{key: "noboiler", text: "No Gas In Property - Office/Agent Aware", value: "No Gas In Property - Office/Agent Aware"},{key: "notpresent", text: "Not Present - Office/Agent aware", value: "Not Present - Office/Agent Aware"}]}></Dropdown> </Message.Content></Message></Grid.Column></Grid.Row>}
          </Grid>
<Divider/>
            {this.state.showAdd && <Segment className="pv-data-input">
              <Form onSubmit={this.handleSubmit}>
                <Form.Group widths='equal'>
                  <Form.Field>
                    <label>Alarm Type</label>
                    <Dropdown  onChange={(e,option) => { this.setState({ alarmType: option.value }) }} inline selection placeholder={"Choose Alarm Type..."}options={[{key: "carbon", text: "Carbon Alarm", value: "Carbon Alarm"},{key: "smoke", text: "Smoke Alarm", value: "Smoke Alarm"},{key: "smoke", text: "Heat Alarm", value: "Heat Alarm"}]}></Dropdown>
                  </Form.Field>
                  <Form.Field>
                    <label>Alarm Location</label>
                    <Input
                      type="text"
                      placeholder="Kitchen"
                      ref="alarmLocation"
                      required
                      value={this.state.alarmLocation}
                      onChange={(e) => {
                        this.setState({ alarmLocation: e.target.value })
                      }}
                    />
                  </Form.Field>

                  <Form.Field>
                    <label>Alarm Description</label>
                    <Input
                      type="text"
                      placeholder="Tested and Audible"
                      ref="alarmDescription"
                      required
                      value={this.state.alarmDescription}
                      onChange={(e) => {
                        this.setState({ alarmDescription: e.target.value });

                      }}
                    />
                  </Form.Field>
                  <Form.Field>
                    <label>Alarm Expiry</label>
                    <Input
                      type="text"
                      placeholder="Expiry Date..."
                      ref="alarmExpiry"
                      required
                      value={this.state.alarmExpiry}
                      onChange={(e) => {
                        this.setState({ alarmExpiry: e.target.value });
                      }}
                    />
                  </Form.Field>
                </Form.Group>
                {this.state.maxNumberOfFilesExceeded &&
                  <p><span className="error-message">Max number of allowed files is 1</span></p>}
                <DropzoneComponent key={this.props.reportId} config={componentConfig}
                  eventHandlers={eventHandlers}
                  djsConfig={djsConfig} />
                <div style={{ textAlign: "center", paddingTop: "15px" }}>
                  <Button primary content="Add New Alarm" type="submit" /></div>
              </Form>
            </Segment>}
            
          </React.Fragment>}
          {this.state.uploading && <Loader contain={true} customText={this.state.uploadState === "image" ? `Uploading Image ${this.state.currentImageCount} of ${this.state.totalImageCount} ` : "Uploading Alarm Data..."}></Loader>}
        </div>
      </Segment>
        );
    }
}

export default PropertyVisitReportAlarms;


// WEBPACK FOOTER //
// ./src/views/property_visits/property_visit_report_alarms.js